import { render, staticRenderFns } from "./FilterGeneric.vue?vue&type=template&id=2fa0ba17"
import script from "./FilterGeneric.vue?vue&type=script&lang=js"
export * from "./FilterGeneric.vue?vue&type=script&lang=js"
import style0 from "./FilterGeneric.vue?vue&type=style&index=0&id=2fa0ba17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports